import React, { useEffect, useState } from "react";
import { api, apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Download, Search } from "lucide-react";

const fmt = (s) => { if (!s) return ""; const [y, m, d] = s.slice(0, 10).split("-"); return `${d}/${m}/${y}`; };

export default function RegistreTab() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/registre").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e))).finally(() => setLoading(false));
  }, []);

  const filtered = rows.filter((r) =>
    !q || `${r.nom} ${r.ville} ${r.accommodation_name}`.toLowerCase().includes(q.toLowerCase()));

  const exportCsv = () => {
    const head = ["Nom", "Adresse", "Code postal", "Ville", "Pays", "E-mail", "Téléphone", "Logement", "Arrivée", "Départ", "Nuits", "Adultes", "Enfants", "Voyageurs", "Taxe séjour (€)"];
    const data = [head, ...filtered.map((r) => [
      r.nom, r.adresse, r.code_postal, r.ville, r.pays, r.email, r.telephone, r.accommodation_name,
      fmt(r.arrivee), fmt(r.depart), r.nights, r.adultes ?? "", r.enfants ?? "", r.voyageurs ?? "", r.tourist_tax ?? "",
    ])];
    const csv = data.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(";")).join("\n");
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `registre-voyageurs-begaudiere.csv`;
    a.click();
  };

  return (
    <div className="space-y-4" data-testid="registre-tab">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher (nom, ville, logement)…"
            className="pl-9 pr-3 py-2 rounded-full border border-slate-200 text-sm w-72 outline-none focus:border-brand" data-testid="registre-search" />
        </div>
        <button onClick={exportCsv} disabled={!filtered.length} className="inline-flex items-center gap-2 rounded-lg bg-slate-900 text-white px-4 py-2 text-sm font-semibold hover:opacity-90 disabled:opacity-50" data-testid="registre-export-csv">
          <Download size={15} /> Export registre (CSV)
        </button>
      </div>
      <p className="text-xs text-ink-400">Registre des voyageurs, utile pour vos obligations d'hébergeur (déclaration, taxe de séjour). {filtered.length} entrée(s).</p>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        {loading ? <p className="p-8 text-center text-slate-400">Chargement…</p> :
          filtered.length === 0 ? <p className="p-8 text-center text-slate-400">Aucune entrée.</p> : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-500 text-xs">
                  <tr>
                    {["Nom", "Ville / Pays", "Logement", "Séjour", "Voyageurs", "Taxe séj."].map((h) => (
                      <th key={h} className="text-left font-semibold px-4 py-3 whitespace-nowrap">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((r) => (
                    <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50 transition-colors" data-testid={`registre-row-${r.id}`}>
                      <td className="px-4 py-2.5 font-medium text-slate-900 whitespace-nowrap">{r.nom || "—"}</td>
                      <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{[r.code_postal, r.ville].filter(Boolean).join(" ") || "—"}{r.pays ? ` · ${r.pays}` : ""}</td>
                      <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{r.accommodation_name || "—"}</td>
                      <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{fmt(r.arrivee)} → {fmt(r.depart)} ({r.nights}n)</td>
                      <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{r.voyageurs ?? "—"}{r.adultes != null ? ` (${r.adultes}A${r.enfants ? "/" + r.enfants + "E" : ""})` : ""}</td>
                      <td className="px-4 py-2.5 text-slate-600 whitespace-nowrap">{r.tourist_tax != null ? `${r.tourist_tax} €` : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </div>
    </div>
  );
}
